module.exports = __webpack_public_path__ + "img/Thailand-4-hover.b95e16fa.jpg";